import { render, staticRenderFns } from "./VQuickRegForm.vue?vue&type=template&id=5518f34a&"
import script from "./VQuickRegForm.vue?vue&type=script&lang=js&"
export * from "./VQuickRegForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports